<div class="footer-basic-copyright">
  © {{ date | date : 'YYYY' }} {{ copyright }}
</div>
<nav class="footer-basic-nav">
  <ul class="footer-basic-links">
    <li *ngFor="let link of links">
      <ng-container [ngSwitch]="link.type">
        <ng-container *ngSwitchCase="'route'">
          <ng-container *ngIf="isRoute(link)">
            <a [routerLink]="link.route">{{ link.label }}</a>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'link'">
          <ng-container *ngIf="isLink(link)">
            <a [href]="link.href" [target]="link.target">{{ link.label }}</a>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'action'">
          <ng-container *ngIf="isAction(link)">
            <a (click)="link.cb()">{{ link.label }}</a>
          </ng-container>
        </ng-container>
      </ng-container>
    </li>
  </ul>
</nav>
